import { Button, Flex, Input, Typography } from 'antd';
import { useState } from 'react';
import './SavingFooter.css';

export enum SavingSteps {
  Title,
  RecipientEmail
}

type AllProps = {
  initTitle?: string;
  isRecipientExists?: boolean;
  isLoading?: boolean;
  onSave: (title: string, recipientEmail?: string) => void;
};

function SavingFooter({ initTitle = '', isRecipientExists = false, isLoading, onSave }: AllProps) {
  const [title, setTitle] = useState(initTitle);
  const [recipientEmail, setRecipientEmail] = useState('');
  const [currentStep, setCurrentStep] = useState<SavingSteps>(SavingSteps.Title);
  const [error, setError] = useState<string>('');

  const onSubmit = () => {
    setError('');

    if (currentStep === SavingSteps.Title) {
      if (title === '') {
        setError('Title is required.');
        return;
      }

      if (isRecipientExists || recipientEmail) {
        onSave(title);
      } else {
        setCurrentStep(SavingSteps.RecipientEmail);
      }
    }

    if (currentStep === SavingSteps.RecipientEmail) {
      if (recipientEmail === '') {
        setError('Recipient email is required.');
        return;
      }

      onSave(title, recipientEmail);
    }
  };

  return (
    <div className="saving-footer">
      {currentStep === SavingSteps.Title && (
        <Flex vertical gap={6}>
          <strong>Name your message</strong>
          <Flex gap={10}>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} required />
            <Button type="primary" onClick={onSubmit} loading={isLoading}>
              {recipientEmail ? 'Save message' : 'Next'}
            </Button>
          </Flex>
          {error && <Typography.Text type="danger">{error}</Typography.Text>}
        </Flex>
      )}
      {currentStep === SavingSteps.RecipientEmail && (
        <Flex vertical gap={6}>
          <strong>Add recipient email</strong>
          <Flex gap={10}>
            <Input value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
            <Button type="primary" onClick={onSubmit} loading={isLoading}>
              Save message
            </Button>
          </Flex>
          {error && <Typography.Text type="danger">{error}</Typography.Text>}
        </Flex>
      )}
    </div>
  );
}

export default SavingFooter;
